import { ref } from 'vue';
import { $api } from '@/services';

const error = ref(null);
const loading = ref(false);

export async function checkToken(data: { token: string | null }) {
	error.value = null;
	try {
		const res = await $api.auth.checkToken(data);
		return res?.data;
	} catch (err) {
		error.value = err?.response?.data?.errors || err.message;
	} finally {
		loading.value = false;
	}
}

export function useCheckToken() {
	return { checkToken__error: error, loading, checkToken };
}
